import React, { memo } from 'react';
import { CONTENT_LINKS, requestOpenContent } from '../../../utils/siteContent';

/**
 * 底部栏（设计稿 251:33，1400 宽与作品区对齐）
 * - 顶线 1400x1 白 15%
 * - 链接行（y=49，水平居中）：#8A8A8A 14px；链接起点步进 89px，
 *   分隔线 1x8 白 15% 位于 16px 间隙中点（56 + 16 + 1 + 16 = 89）
 * - 版权行（y=87，水平居中）：#666666 12px Light；公司名无字距，中/右两段字距 0.04em，段间距 24px
 * - 链接 → 站点内容页（/content?slug=...）：SPA 内经 CustomEvent 切视图，
 *   href 保留真实路由供新标签打开（刷新可恢复）
 */

const FooterBarComponent: React.FC = () => {
  return (
    <footer className="w-full">
      <div className="mx-auto w-full max-w-[1400px]">
        {/* 顶线 */}
        <div className="h-px w-full bg-white/15" />

        {/* 链接行：设计分隔线 2517 → 链接文字顶 2555（间距 38px，含字形内缩），水平居中 */}
        <nav className="mt-[38px] flex items-center justify-center">
          {CONTENT_LINKS.map((link, index) => (
            <React.Fragment key={link.slug}>
              {index > 0 && <span className="mx-4 h-2 w-px bg-white/15" />}
              <a
                href={`/content?slug=${link.slug}`}
                onClick={(e) => {
                  e.preventDefault();
                  requestOpenContent(link.slug);
                }}
                className="text-[14px] leading-[14px] text-[#8A8A8A] transition-colors hover:text-white"
              >
                {link.label}
              </a>
            </React.Fragment>
          ))}
        </nav>

        {/* 版权行：设计链接 2555 → 版权文字顶 2596；链接行高 14 + 间距 27 */}
        <div className="mt-[27px] flex items-center justify-center text-[12px] font-light leading-[12px] text-[#666666]">
          <span>中山双生科技有限公司</span>
          <span className="mx-6" style={{ letterSpacing: '0.04em' }}>
            @ 2026 Bong AI. All rights reserved.
          </span>
          <span style={{ letterSpacing: '0.04em' }}>粤ICP备2026142713号-1</span>
        </div>

        {/* 底部留白：设计版权底 2608 → 页底 2650 = 42，扣除字形内缩取 40（页脚总高 133） */}
        <div className="h-[40px]" />
      </div>
    </footer>
  );
};

export const FooterBar = memo(FooterBarComponent);
